import { render, staticRenderFns } from "./ModalShipmentCreate.vue?vue&type=template&id=573b1876&scoped=true&"
import script from "./ModalShipmentCreate.vue?vue&type=script&lang=js&"
export * from "./ModalShipmentCreate.vue?vue&type=script&lang=js&"
import style0 from "./ModalShipmentCreate.vue?vue&type=style&index=0&id=573b1876&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "573b1876",
  null
  
)

export default component.exports